import { memo, useCallback, useMemo, useSyncExternalStore } from 'react';
import { SelectionElementType } from '../../Outlines/types';
import FontSelector from '@/Pages/Clip/SideBar/FontSelector/FontSelector';
import { clipsBrandKit } from '@/stores/brandKit';
import { loadFont } from '@/libs/fonts';
import { getFileNameFromPath, getFileNameWithoutExtension } from '@/libs/file';

interface Props {
  value?: string;
  onChange: (fontName: string, fontLocation: string) => void;
  clipId: string;
}

const SpeakerLabelFontSelector = memo(({ value, onChange, clipId }: Props) => {
  const clipsBrandKitStore = useSyncExternalStore(clipsBrandKit.subscribe, clipsBrandKit.getSnapshot);

  const displayedFontName = useMemo(() => {
    if (!value) {
      return 'Default';
    }
    return (
      clipsBrandKitStore[clipId]?.fontsMap?.predefined?.[value] ||
      clipsBrandKitStore[clipId]?.fontsMap?.brandKit?.[value] ||
      getFileNameWithoutExtension(getFileNameFromPath(value))
    );
  }, [value, clipsBrandKitStore, clipId]);

  const handleFontChange = useCallback(
    (fontName: string, fontLocation: string) => {
      // Load font if not already loaded
      if (fontLocation && fontName !== 'Default') {
        loadFont(fontLocation, fontName).catch(console.error);
      }

      onChange(fontName, fontLocation);
    },
    [onChange]
  );

  return (
    <FontSelector
      isInline={true}
      fontTarget={SelectionElementType.SPEAKER_LABEL}
      onChange={handleFontChange}
      selectedFontName={displayedFontName}
      selectedFontLocation={value}
    />
  );
});

export default SpeakerLabelFontSelector;
